import { createContext, useContext } from "react";
import { initialStandardsModalContext } from "./StandardsModalProvider.constants";
import { IStandardsModalContext } from "./StandardsModalProvider.types";

export const StandardsModalContext = createContext<IStandardsModalContext>(
  initialStandardsModalContext,
);

export const useStandardsModalContext = () => useContext(StandardsModalContext);
